import config from "environment";
import { postRequest, deleteRequest } from "./client";
import { PersonaLinkRecordOrientation } from "winslow-core";

const { baseApi } = config;

interface CreatePersonaLinkRecordPayload {
  linkRecordId: string;
  personaId: string;
  orientation: PersonaLinkRecordOrientation;
}

interface UpdatePersonaLinkRecordPayload {
  linkRecordId: string;
  personaId: string;
  orientation: PersonaLinkRecordOrientation;
}

export async function apiCreatePersonaLinkRecord(
  payload: CreatePersonaLinkRecordPayload
): Promise<{ success: boolean }> {
  const fetchURL = `${baseApi}/personas/persona-link-records`;
  return await postRequest(fetchURL, payload, "API/apiCreatePersonaLinkRecord");
}

export async function apiUpdatePersonaLinkRecord(
  payload: UpdatePersonaLinkRecordPayload
): Promise<{ success: boolean }> {
  const fetchURL = `${baseApi}/personas/persona-link-records/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdatePersonaLinkRecord");
}

export async function apiDeletePersonaLinkRecord(
  linkRecordId: string,
  personaId: string
): Promise<{ success: boolean }> {
  const fetchURL = `${baseApi}/personas/persona-link-records/${linkRecordId}/${personaId}`;
  return await deleteRequest(fetchURL, "API/apiDeletePersonaLinkRecord");
}
